<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="100128" />
    <section slot="titleLeft">
      【收入：
      <span class="primary">{{ incomeTotalData.amountSum }}</span>
      】 【支出：
      <span class="primary">{{ expendTotalData.amountSum  }}</span>
      】
    </section>
    <section slot="titleRight">
      【实时余额：
      <span class="primary">{{ balanceTotalData.balanceSum}}</span>
      】
      <qx-permpisions permpisions="">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="incomeAndExpenditureBO.ajax?cmd=queryIncomeAndExpendPage"
          :params="fullSearchData"
          bizName="收支明细数据导出"
          bizCode="exp1000129"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title"/>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
<!--          <el-table-column type="selection" width="55" />-->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'transactionAmount'">
                  <span class="primary cur" v-if="scope.row.transactionType === 1 || scope.row.transactionType ===2 ">
                    <span>+</span>
                    <span>{{scope.row[scope.column.property] }}</span>
                  </span>
                  <span class="primary cur" v-if="scope.row.transactionType === 3 || scope.row.transactionType ===4 ">
                    {{ - scope.row[scope.column.property] }}
                  </span>
                </section>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->

          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions permpisions="">
                  <span class="primary cur" @click="showLog(scope.row.id)"
                    >日志</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import LogRightDialog from 'components/logRightDialog';


import TableSetting from 'components/tableSetting/tableSetting';
import {
  accountBalanceTotal, incomeAndExpenseTotal, incomeDetailList,
} from 'api/getPay';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    LogRightDialog,
    TableSetting,
  },
  data () {
    return {
      incomeTotalData: {
        amountSum: 0, // 收入
      },
      expendTotalData: {
        amountSum: 0, // 支出
      },
      balanceTotalData: {
        balanceSum: 0,
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        // selectTar: 'orderId',
        title: [ // 表头
          { prop: 'transactionNoFlow', label: '交易流水', fixed: true },
          { prop: 'accountName', label: '账户名称' },
          { prop: 'bankCardNo', label: '银行卡号' },
          { prop: 'accountTypeName', label: '账户类型' },
          { prop: 'transactionModeName', label: '交易方式' },
          { prop: 'transactionTime', label: '交易时间' },
          { prop: 'transactionAmount', label: '交易金额' },
          { prop: 'accountBalance', label: '账户余额' },
          { prop: 'oppositeAccountNumber', label: '对方账号' },
          { prop: 'oppositeAccountName', label: '对方户名' },
          { prop: 'transactionPurposeName', label: '交易用途' },
          { prop: 'remark', label: '备注' },
          // { prop: 'transactionType', label: '', w: '1px' }, // 原型上没有此列，由于导出时需要导出表格左上角收入支出统计，后端不好做，所以加此列不显示label即可
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: incomeDetailList,
    async getOtherMsg (params) {
      const incomeRes = await incomeAndExpenseTotal(params); // 收入支出统计
      if (!incomeRes.failed) {
        for (let i = 0; i < incomeRes.items.length; i++) {
          if (incomeRes.items[i].transactionType === 'income') {
            this.incomeTotalData = incomeRes.items[i] || {
              amountSum: 0, // 收入
            };
          }
          if (incomeRes.items[i].transactionType === 'expend') {
            this.expendTotalData = incomeRes.items[i] || {
              amountSum: 0, // 支出
            };
          }
        }
      }

      const balanceRes = await accountBalanceTotal(params); // 账户余额统计
      if (!balanceRes.failed) {
        this.balanceTotalData = balanceRes;

      }
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
